import { V as VaAccordion } from "../../components/va-accordion/index-c2d30770.mjs";
import { V as VaAffix } from "../../components/va-affix/index-c5e5f46b.mjs";
import { V as VaAlert } from "../../components/va-alert/index-587e1d48.mjs";
import { V as VaAppBar } from "../../components/va-app-bar/index-dc176e7c.mjs";
import { V as VaAspectRatio } from "../../components/va-aspect-ratio/index-059c82f7.mjs";
import { V as VaAvatar } from "../../components/va-avatar/index-84aec4b5.mjs";
import { V as VaAvatarGroup } from "../../components/va-avatar-group/index-57e25f53.mjs";
import { V as VaBacktop } from "../../components/va-backtop/index-86a47684.mjs";
import { V as VaBadge } from "../../components/va-badge/index-e5cc8a8a.mjs";
import { a as VaBreadcrumbs, V as VaBreadcrumbsItem } from "../../components/va-breadcrumbs/index-696950bd.mjs";
import { V as VaButton } from "../../components/va-button/index-1db585d5.mjs";
import { V as VaButtonDropdown } from "../../components/va-button-dropdown/index-edac19cc.mjs";
import { V as VaButtonGroup } from "../../components/va-button-group/index-7562beb4.mjs";
import { V as VaButtonToggle } from "../../components/va-button-toggle/index-c71120ea.mjs";
import { d as VaCard, b as VaCardActions, c as VaCardBlock, V as VaCardContent, a as VaCardTitle } from "../../components/va-card/index-8f0cf1cc.mjs";
import { V as VaCarousel } from "../../components/va-carousel/index-0815012c.mjs";
import { V as VaCheckbox } from "../../components/va-checkbox/index-9272786f.mjs";
import { V as VaChip } from "../../components/va-chip/index-1fea3cc5.mjs";
import { V as VaCollapse } from "../../components/va-collapse/index-1287247d.mjs";
import { V as VaColorIndicator } from "../../components/va-color-indicator/index-38941117.mjs";
import { V as VaColorInput } from "../../components/va-color-input/index-e2fe9630.mjs";
import { V as VaColorPalette } from "../../components/va-color-palette/index-566dfe86.mjs";
import { V as VaConfig } from "../../components/va-config/VaConfig-785c45a1.mjs";
import { V as VaContent } from "../../components/va-content/index-965a86f2.mjs";
import { V as VaCounter } from "../../components/va-counter/index-bd17b838.mjs";
import { V as VaDataTable } from "../../components/va-data-table/index-f955ff1f.mjs";
import { V as VaDateInput } from "../../components/va-date-input/index-7fd0d868.mjs";
import { V as VaDatePicker } from "../../components/va-date-picker/index-81b2c444.mjs";
import { V as VaDivider } from "../../components/va-divider/index-ff85d97f.mjs";
import { V as VaDropdown } from "../../components/va-dropdown/index-9e0e771a.mjs";
import { V as VaDropdownContent } from "../../components/va-dropdown/components/VaDropdownContent/index-0209c7a0.mjs";
import { V as VaFallback } from "../../components/va-fallback/index-c7099275.mjs";
import { V as VaFileUpload } from "../../components/va-file-upload/index-18324a82.mjs";
import { V as VaForm } from "../../components/va-form/index-66ecb023.mjs";
import { V as VaHover } from "../../components/va-hover/index-75c7258c.mjs";
import { V as VaIcon } from "../../components/va-icon/index-7fefcddb.mjs";
import { V as VaImage } from "../../components/va-image/index-c84f2dd1.mjs";
import { V as VaInfiniteScroll } from "../../components/va-infinite-scroll/index-9cdc3ef5.mjs";
import { V as VaInnerLoading } from "../../components/va-inner-loading/index-5ae3376b.mjs";
import { V as VaInput } from "../../components/va-input/index-a46ef122.mjs";
import { b as VaList, V as VaListItem, d as VaListItemLabel, a as VaListItemSection, c as VaListLabel, e as VaListSeparator } from "../../components/va-list/index-d370814a.mjs";
import { V as VaMessageList } from "../../components/va-input/components/VaMessageList/index-3de9699a.mjs";
import { V as VaModal } from "../../components/va-modal/VaModal-b1dd8919.mjs";
import { V as VaNavbar, a as VaNavbarItem } from "../../components/va-navbar/index-15641e4a.mjs";
import { V as VaOptionList } from "../../components/va-option-list/index-0392c22b.mjs";
import { V as VaPagination } from "../../components/va-pagination/index-dbd9e257.mjs";
import { V as VaParallax } from "../../components/va-parallax/index-f363fb72.mjs";
import { V as VaPopover } from "../../components/va-popover/index-862e71a5.mjs";
import { V as VaProgressBar } from "../../components/va-progress-bar/index-ef09d849.mjs";
import { V as VaProgressCircle } from "../../components/va-progress-circle/index-ad19302c.mjs";
import { V as VaRadio } from "../../components/va-radio/index-b41b3ca0.mjs";
import { V as VaRating } from "../../components/va-rating/index-c19356b5.mjs";
import { V as VaSelect } from "../../components/va-select/index-ac0feb4c.mjs";
import { V as VaSeparator } from "../../components/va-separator/VaSeparator-441efce1.mjs";
import { V as VaSkeleton, a as VaSkeletonGroup } from "../../components/va-skeleton/index-4e0faf13.mjs";
import { V as VaSidebar } from "../../components/va-sidebar/index-4f84abd2.mjs";
import { V as VaSidebarItem, a as VaSidebarItemContent, b as VaSidebarItemTitle } from "../../components/va-sidebar/VaSidebarItem/index-53fbc5ec.mjs";
import { V as VaSlider } from "../../components/va-slider/index-ec4337fa.mjs";
import { V as VaSpacer } from "../../components/va-spacer/VaSpacer-c6cc3351.mjs";
import { V as VaSplit } from "../../components/va-split/index-9ef6d1e5.mjs";
import { V as VaSwitch } from "../../components/va-switch/index-0aad792f.mjs";
import { V as VaTabs } from "../../components/va-tabs/index-33fdc16a.mjs";
import { V as VaTab } from "../../components/va-tabs/components/VaTab/index-2fd17abd.mjs";
import { V as VaStepper } from "../../components/va-stepper/index-a46dc64e.mjs";
import { V as VaTimeInput } from "../../components/va-time-input/index-e6dd8bf1.mjs";
import { V as VaTimeline } from "../../components/va-timeline/index-7194db84.mjs";
import { V as VaTimelineItem } from "../../components/va-timeline/VaTimelineItem/index-a97b2090.mjs";
import { V as VaTimePicker } from "../../components/va-time-picker/index-5b3d453f.mjs";
import { V as VaToast } from "../../components/va-toast/index-5990aca3.mjs";
import { V as VaTreeView } from "../../components/va-tree-view/index-240447e0.mjs";
import { V as VaScrollContainer } from "../../components/va-scroll-container/index-3beee7bb.mjs";
import { V as VaViewer } from "../../components/va-viewer/index-c76589e8.mjs";
import { V as VaValue } from "../../components/va-value/index-f4d83597.mjs";
import { V as VaVirtualScroller } from "../../components/va-virtual-scroller/index-e610df5f.mjs";
const vuesticComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VaAccordion,
  VaAffix,
  VaAlert,
  VaAppBar,
  VaAspectRatio,
  VaAvatar,
  VaAvatarGroup,
  VaBacktop,
  VaBadge,
  VaBreadcrumbs,
  VaBreadcrumbsItem,
  VaButton,
  VaButtonDropdown,
  VaButtonGroup,
  VaButtonToggle,
  VaCard,
  VaCardActions,
  VaCardBlock,
  VaCardContent,
  VaCardTitle,
  VaCarousel,
  VaCheckbox,
  VaChip,
  VaCollapse,
  VaColorIndicator,
  VaColorInput,
  VaColorPalette,
  VaConfig,
  VaContent,
  VaCounter,
  VaDataTable,
  VaDateInput,
  VaDatePicker,
  VaDivider,
  VaDropdown,
  VaDropdownContent,
  VaFallback,
  VaFileUpload,
  VaForm,
  VaHover,
  VaIcon,
  VaImage,
  VaInfiniteScroll,
  VaInnerLoading,
  VaInput,
  VaList,
  VaListItem,
  VaListItemLabel,
  VaListItemSection,
  VaListLabel,
  VaListSeparator,
  VaMessageList,
  VaModal,
  VaNavbar,
  VaNavbarItem,
  VaOptionList,
  VaPagination,
  VaParallax,
  VaPopover,
  VaProgressBar,
  VaProgressCircle,
  VaRadio,
  VaRating,
  VaScrollContainer,
  VaSelect,
  VaSeparator,
  VaSidebar,
  VaSidebarItem,
  VaSidebarItemContent,
  VaSidebarItemTitle,
  VaSkeleton,
  VaSkeletonGroup,
  VaSlider,
  VaSpacer,
  VaSplit,
  VaStepper,
  VaSwitch,
  VaTab,
  VaTabs,
  VaTimeInput,
  VaTimePicker,
  VaTimeline,
  VaTimelineItem,
  VaToast,
  VaTreeView,
  VaValue,
  VaViewer,
  VaVirtualScroller
}, Symbol.toStringTag, { value: "Module" }));
export {
  vuesticComponents as v
};
//# sourceMappingURL=components-b0642296.mjs.map
